export const STATE_DEFAULT = 'state:default';
export const STATE_LOADING = 'state:loading';
export const STATE_RESTORED = 'state:restored';
export const TRACKING_TITLE_CONDITIONS = 'Conditions';
export const TRACKING_TITLE_SELFIE = 'Selfie';
export const TRACKING_CATEGORY_PRODUCT_RECOMMENDATION = 'Product Recommendation';
export const USER_ACTION_DIAGNOSIS_STARTED = ['skin_advisor', 'Skin diagnosis started'];
export const USER_ACTION_DIAGNOSIS_COMPLETED = ['skin_advisor', 'Skin diagnosis completed'];
export const WITH_SELFIE = 'With selfie';
export const WITHOUT_SELFIE = 'Without selfie';
